import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

export const offlineFutureStocksRepository = {
  ...createOfflineCommonRepository(() => offlineDatabase.futureStocks),
  findByProductAndColorId: ({ productColorId, productId }: FindByProductAndColorIdParams) => {
    return offlineDatabase.futureStocks
      .filter(
        (futureStock) =>
          futureStock.productId === productId && futureStock.productColorId === productColorId,
      )
      .toArray();
  },
  findByProductColorDeliveryWindowAndSkuIds: ({
    skuIds,
    productColorId,
    deliveryWindowId,
  }: FindByProductColorDeliveryWindowAndSkuIdsParams) => {
    return offlineDatabase.futureStocks
      .filter(
        (futureStock) =>
          futureStock.productColorId === productColorId &&
          futureStock.deliveryWindowId === deliveryWindowId &&
          skuIds.includes(futureStock.skuId),
      )
      .toArray();
  },
  findByProductColorAndDeliveryWindowId: ({
    deliveryWindowId,
    productColorId,
  }: FindByProductColorAndDeliveryWindowIdParams) => {
    return offlineDatabase.futureStocks
      .filter(
        (futureStock) =>
          futureStock.productColorId === productColorId &&
          futureStock.deliveryWindowId === deliveryWindowId,
      )
      .toArray();
  },
  findByProductColorIdAndDeliveryWindowIds: ({
    productColorId,
    deliveryWindowIds,
  }: FindByProductColorIdAndDeliveryWindowIdsParams) => {
    const deliveryWindowIdsSet = new Set(deliveryWindowIds);
    return offlineDatabase.futureStocks
      .filter(
        (futureStock) =>
          futureStock.productColorId === productColorId &&
          deliveryWindowIdsSet.has(futureStock.deliveryWindowId),
      )
      .toArray();
  },
};

interface FindByProductAndColorIdParams {
  productId: string;
  productColorId: string;
}

interface FindByProductColorDeliveryWindowAndSkuIdsParams {
  skuIds: string[];
  productColorId: string;
  deliveryWindowId: string;
}

interface FindByProductColorAndDeliveryWindowIdParams {
  productColorId: string;
  deliveryWindowId: string;
}

interface FindByProductColorIdAndDeliveryWindowIdsParams {
  productColorId: string;
  deliveryWindowIds: string[];
}
